import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterSelect } from "../../features/Filter/filterSlice";

export default function BookFilter() {
  const {filter} = useSelector(state=> state.filter)
  const dispatch = useDispatch()
  const handleAllFilter = ()=>{dispatch(filterSelect("All"))}
  const handleFeatureFilter = ()=>{dispatch(filterSelect("Featured"))}
  return (
    <div className="flex items-center space-x-4">
      <button className={`lws-filter-btn ${filter === "All" && "active-filter"}`} onClick={handleAllFilter}>All</button>
      <button className={`lws-filter-btn ${filter === "Featured" && "active-filter"}`} onClick={handleFeatureFilter}>Featured</button>
    </div>
  );
}
